module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_taiken-dedb28f92e9e6b0d1984337d3c778233.jpg";